import React, { CSSProperties } from "react";
import FooterPanel from "./FooterPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { ButtonVariants, ButtonVariantsEnum } from "../../styles/fluent/ButtonVariants";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import HeaderPanel from "./HeaderPanel";
import { Modal } from "@fluentui/react";

export const ColorVariantsMap = {
  delete: "var(--color-red)",
  confirm: "var(--color-yellow)",
};
export type ModalVariantsEnum = keyof typeof ColorVariantsMap;

export interface ModalAction {
  onClick: () => void;
  id?: string;
  title: string;
  variant: ButtonVariantsEnum;
  style?: CSSProperties;
  disabled?: boolean;
}

export interface CustomModalProps {
  modalTitle: string;
  messageTitle: string;
  message: any;
  type: ModalVariantsEnum;
  actions: ModalAction[];
  onHide: () => void;
}

export const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    minHeight: "100vh",
    minWidth: "100vw",
  },
});

export const CustomModal: React.FunctionComponent<CustomModalProps> = (props) => {
  const { messageTitle, modalTitle, message, type, actions, onHide } = props;

  return (
    <Modal titleAriaId={"titleId"} isOpen={true} containerClassName={contentStyles.container}>
      <HeaderPanel applyPadding borderColor={ColorVariantsMap[type]}>
        {modalTitle}
      </HeaderPanel>
      <div
        className="messageText"
        style={{
          margin: "12px 8px",
          padding: "8px 8px",
          borderRadius: "8px",
          backgroundColor: ColorVariantsMap[type],
          color: "white",
        }}
      >
        {messageTitle}
      </div>
      {message && (
        <div className="bodyText" style={{ margin: "0 8px 12px 8px" }} dangerouslySetInnerHTML={{ __html: message }} />
      )}

      <FooterPanel>
        <div
          className="ms-Grid-col ms-xs12 ms-sm12 ms-md12 ms-lg12"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {actions.map((action, index) => (
            <PrimaryButton
              id={action.id}
              text={action.title}
              onClick={() => {
                action.onClick();
                onHide();
              }}
              disabled={action.disabled}
              key={index}
              className={ButtonVariants[action.variant]}
              style={action.style}
            />
          ))}
        </div>
      </FooterPanel>
    </Modal>
  );
};
